// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"e6dac18b","775":"0096b0f3"}[chunkId] + ".chunk.js";
};